import * as C from 'actions/constants';

export const blankState = {
  list: [],
  count: 0,
  isOpen: false,
};

const ExportReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_EXPORTS:
    case C.CREATE_EXPORT:
    case C.DELETE_EXPORT: {
      return { ...state, loading: true };
    }
    case C.LOAD_EXPORTS_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, ...data };
    }
    case C.CREATE_EXPORT_SUCCESS:
    case C.CREATE_EXPORT_ERROR:
    case C.LOAD_EXPORTS_ERROR:
    case C.DELETE_EXPORT_SUCCESS:
    case C.DELETE_EXPORT_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default ExportReducer;
